import get from 'transmute/get';
export const getVisitorIdentification = get('visitorIdentification');